<header id="header " class="vehicle-details public-header">
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <img routerLink="/" class="img-header-logo" src="assets/images/logo-white.png" alt="MegaAutos" />
            </div>
            <div class="col-md-8">
                <nav class="header-menu">
                    <a class="header-menu-lnk" href="#header">Início</a>
                    <a class="header-menu-lnk" href="#gallery">Veículos</a>
                    <a class="header-menu-lnk" href="#services">Serviços</a>
                    <a class="header-menu-lnk" href="#map">Contato</a>
                </nav>
            </div>
        </div>
    </div>
</header>
<main>
    <div class="container">
        <div class="row row-content">
            <div class="col-md-8">
                <div class="vehicle-main-info">
                    <h2 class="vehicle-name">{{vehicle.Manufacturer}} {{vehicle.Name}}</h2>
                    <h3 class="vehicle-model">{{vehicle.Model}}</h3>
                </div>
                <div class="vehicle-images">
                    <ngx-slick-carousel class="main-carousel" #slickModalMain="slick-carousel" [config]="mainSlideConfig">
                        <div ngxSlickItem *ngFor="let slide of vehicleImages; let i = index" class="slide">
                            <img class="img-vehicle" src="{{ slide.ImageURL }}" alt="{{slide.Name}}">
                        </div>
                    </ngx-slick-carousel>
                    <ngx-slick-carousel class="small-carousel" #slickModalSmall="slick-carousel" [config]="smallSlideConfig">
                        <div ngxSlickItem *ngFor="let slide of vehicleImages; let i = index" class="slide" (click)="slickModalMain.slickGoTo(i)">
                            <img class="img-vehicle" src="{{ slide.ImageURL }}" alt="{{slide.Name}}">
                        </div>
                    </ngx-slick-carousel>
                </div>
                <div class="vehicle-summary mobile">
                    <div class="vehicle-value">
                        <span class="currency">R$</span> {{vehicle.SaleValue | number}}
                    </div>
                    <div class="vehicle-summary-info">
                        <label class="lbl">Fabricante</label>
                        <label class="value">{{vehicle.Manufacturer}}</label>
                        <br /><br />
                        <label class="lbl">Modelo</label>
                        <label class="value">{{vehicle.Model}}</label>
                    </div>
                    <div class="vehicle-summary-info grid-2">
                        <div>
                            <label class="lbl">Ano</label>
                            <label class="value">{{vehicle.Year}}</label>
                        </div>
                        <div>
                            <label class="lbl">KM</label>
                            <label class="value">{{vehicle.Km}}</label>
                        </div>
                        <div>
                            <label class="lbl">Câmbio</label>
                            <label class="value">{{vehicle.Gearbox}}</label>
                        </div>
                        <div>
                            <label class="lbl">Combustível</label>
                            <label class="value">{{vehicle.Fuel}}</label>
                        </div>
                        <div>
                            <label class="lbl">Cor</label>
                            <label class="value">{{vehicle.Color}}</label>
                        </div>
                        <div>
                            <label class="lbl">Final da placa</label>
                            <label class="value">{{vehicle.LicensePlate}}</label>
                        </div>
                    </div>
                    <div class="vehicle-summary-info grid-2">
                        <div>
                            <label class="lbl">Vistoria cautelar</label>
                            <label class="value"><i class="fas fa-check-circle color-green"></i></label>
                        </div>
                        <div>
                            <label class="lbl">Revisão mecânica</label>
                            <label class="value"><i class="fas fa-check-circle color-green"></i></label>
                        </div>
                        <div>
                            <label class="lbl">Revitalização estética</label>
                            <label class="value"><i class="fas fa-check-circle color-green"></i></label>
                        </div>
                        <div>
                            <label class="lbl">Higienização</label>
                            <label class="value"><i class="fas fa-check-circle color-green"></i></label>
                        </div>
                    </div>
                    <div class="vehicle-summary-obs">
                        {{vehicle.Observations}}
                    </div>
                </div>
                <div class="financial-info">
                    <h3 class="financial-title">Quer financiar com a melhor taxa?</h3>
                    <h4 class="financial-sub-title">Insira seus dados que nós entraremos em contato com você</h4>
                    <div class="form" [formGroup]="form">
                        <div class="row">
                            <div class="col-md-8">
                                <label class="lbl mandatory">Nome</label>
                                <input placeholder="Informe seu nome" formControlName="Name" type="text" value="" />
                            </div>
                            <div class="col-md-4">
                                <label class="lbl mandatory">CPF</label>
                                <input formControlName="Document" type="text" value="" mask="000.000.000-99" [showMaskTyped]="true" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="lbl mandatory">E-mail</label>
                                <input placeholder="Informe seu e-mail" formControlName="Email" type="text" value="" />
                            </div>
                            <div class="col-md-4">
                                <label class="lbl mandatory">Telefone</label>
                                <input formControlName="Phone" type="text" value="" mask="(00) 0 0000-0000" [showMaskTyped]="true" />
                            </div>
                            <div class="col-md-4">
                                <label class="lbl mandatory">Data nascimento</label>
                                <input formControlName="Birthdate" type="date" value="" />
                            </div>
                        </div>
                        <div class="financial-footer-info">
                            <span>
                                <i class="fas fa-info-circle icon"></i>A Mega Autos se compromete a não compartilhar seus dados com terceiros.
                            </span>
                            <a [ngClass]="form.status == 'INVALID' ? 'disabled' : ''" (click)="lnkVehicleMessage()" class="btn btn-primary">Enviar mensagem</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="vehicle-summary desktop">
                    <div class="vehicle-value">
                        <span class="currency">R$</span> {{vehicle.SaleValue | number}}
                    </div>
                    <div class="vehicle-summary-info">
                        <label class="lbl">Fabricante</label>
                        <label class="value">{{vehicle.Manufacturer}}</label>
                        <br /><br />
                        <label class="lbl">Modelo</label>
                        <label class="value">{{vehicle.Model}}</label>
                    </div>
                    <div class="vehicle-summary-info grid-2">
                        <div>
                            <label class="lbl">Ano</label>
                            <label class="value">{{vehicle.Year}}</label>
                        </div>
                        <div>
                            <label class="lbl">KM</label>
                            <label class="value">{{vehicle.Km}}</label>
                        </div>
                        <div>
                            <label class="lbl">Câmbio</label>
                            <label class="value">{{vehicle.Gearbox}}</label>
                        </div>
                        <div>
                            <label class="lbl">Combustível</label>
                            <label class="value">{{vehicle.Fuel}}</label>
                        </div>
                        <div>
                            <label class="lbl">Cor</label>
                            <label class="value">{{vehicle.Color}}</label>
                        </div>
                        <div>
                            <label class="lbl">Final da placa</label>
                            <label class="value">{{vehicle.LicensePlate}}</label>
                        </div>
                    </div>
                    <div class="vehicle-summary-info grid-2">
                        <div>
                            <label class="lbl">Vistoria cautelar</label>
                            <label class="value"><i class="fas fa-check-circle color-green"></i></label>
                        </div>
                        <div>
                            <label class="lbl">Revisão mecânica</label>
                            <label class="value"><i class="fas fa-check-circle color-green"></i></label>
                        </div>
                        <div>
                            <label class="lbl">Revitalização estética</label>
                            <label class="value"><i class="fas fa-check-circle color-green"></i></label>
                        </div>
                        <div>
                            <label class="lbl">Higienização</label>
                            <label class="value"><i class="fas fa-check-circle color-green"></i></label>
                        </div>
                    </div>
                    <div class="vehicle-summary-obs">
                        {{vehicle.Observations}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
<app-footer></app-footer>